import React from "react";
import TokenList from "../components/TokenList";
import "./TokenPage.css";
function TokenPage({ authToken, reload }) {
  return (
    <div className="token-list-section">
      <h2 className="token-list-title">Recent Tokens</h2>
      <TokenList authToken={authToken} refreshTrigger={reload} />
    </div>
  );
}

export default TokenPage;
